export default __webpack_public_path__ + "static/media/dollar-icon.7ee2d332.webp";